/**
 * Minimum CIV floor for sponsor pledges on Volunteer Pay Forward events.
 * Matches backend effective minimum when possible; uses platform default from
 * settings when the event payload omits computed fields (e.g. some list APIs).
 *
 * @param {object} [event]
 * @param {number | null | undefined} platformDefault - from GET settings/default_minimum_required_pledge_amount
 * @returns {number | null}
 */
export function effectiveMinimumPledgeForEvent(event, platformDefault) {
  if (!event?.volunteer_pay_forward) return null
  if (event.effective_minimum_required_pledge_amount != null) {
    return event.effective_minimum_required_pledge_amount
  }
  if (event.minimum_required_pledge_amount != null) {
    return event.minimum_required_pledge_amount
  }
  if (platformDefault != null) return platformDefault
  return null
}
